import verge from 'verge'

import {reducer} from './helpers'
import {UPDATE_RAW_SCROLL, UPDATE_SCROLL, UPDATE_VIEWPORT} from '../actions/pane'

const initialState = {
  rawScrollX: 0,
  rawScrollY: 0,
  scrollX: 0,
  scrollY: 0,
  viewportWidth: verge.viewportW(),
  viewportHeight: verge.viewportH(),
}

export default reducer(initialState, (state, action) => {
  switch (action.type) {
    case UPDATE_RAW_SCROLL:
      return {
        rawScrollX: action.rawScrollX,
        rawScrollY: action.rawScrollY,
      }
    case UPDATE_SCROLL:
      return {
        rawScrollX: action.scrollX,
        rawScrollY: action.scrollY,
        scrollX: action.scrollX,
        scrollY: action.scrollY,
      }
    case UPDATE_VIEWPORT:
      return {
        viewportWidth: action.viewportWidth,
        viewportHeight: action.viewportHeight,
      }
    default:
      return null
  }
})
